//#region src/utils/unescape.ts
function e(e) {
	if (typeof document > "u") return e;
	let t = document.createElement("textarea");
	return t.innerHTML = e, t.value;
}
function t(e) {
	return !e || e.trim() === "" ? "" : new DOMParser().parseFromString(e, "text/html").documentElement.textContent?.trim() || "";
}
//#endregion
export { t as htmlToTextContent, e as unescape };
